const BASE_Z_INDEX = 10000;

/**
 * The base class for the toast tray container.
 */
export const BASE_CLASS = 'toaster-container';

/**
 * Builds the container className by location
 */
export const buildContainerClass = (location: string) => `${BASE_CLASS}-${location}`;

/**
 * The base styles for the toasts' container.
 */
export const BASE_STYLE = {
    position: 'fixed',
    zIndex: BASE_Z_INDEX + 1600
};

/**
 * The base styles for all centered toasts' containers.
 */
export const CENTER_CONTAINERS_STYLE = {
    left: '50%',
    transform: 'translateX(-50%)'
};
